// 3rd party
import React from "react"

function Title({children}) {
  return <h3 className="lower">{children}</h3>
}

export default Title
